import React, { type FC, useCallback, useState } from 'react'
import { CSSTransition } from 'react-transition-group'
import { DrawerContent, DrawerRoot } from '@frontend/pole-ui/lib/components/Drawer'
import { PreApprovedLoanBanner } from '@/components/banners/PreApprovedLoanBanner'
import Portal from '@/components/composed/Portal'
import { setUserClickedOnSubmitInPreApprovedPopupFlag } from '@/pages/MFOPage/helpers'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import './styles.scss'

export const FinancingPreApprovedLoanBanner: FC = () => {
  const [isOpen, setIsOpen] = useState(true)
  const { isMobile } = useDeviceType()

  const handleClose = useCallback(() => {
    setIsOpen(false)
  }, [])

  const handleSubmit = useCallback(() => {
    setIsOpen(false)
    setUserClickedOnSubmitInPreApprovedPopupFlag()
  }, [])

  if (isMobile) {
    return (
      <DrawerRoot open={isOpen} onClose={handleClose}>
        <DrawerContent title="">
          <PreApprovedLoanBanner
            className="financingPreApprovedLoanBanner"
            logoClassName="financingPreApprovedLoanBanner__logo"
            headerClassName="financingPreApprovedLoanBanner__header"
            footerClassName="financingPreApprovedLoanBanner__header"
            submitButtonClassName="financingPreApprovedLoanBanner__submitButton"
            titleClassName="h3"
            submitButtonModifiers={['green']}
            onClickSubmitButton={handleSubmit}
          />
        </DrawerContent>
      </DrawerRoot>
    )
  }

  return (
    <Portal>
      <CSSTransition appear mountOnEnter unmountOnExit in={isOpen} timeout={200} classNames="fading">
        <PreApprovedLoanBanner
          className="financingPreApprovedLoanBanner"
          logoClassName="financingPreApprovedLoanBanner__logo"
          headerClassName="financingPreApprovedLoanBanner__header"
          titleClassName="h4"
          descriptionClassName="text_small"
          submitButtonModifiers={['green', 'small']}
          onClose={handleClose}
          onClickSubmitButton={handleSubmit}
        />
      </CSSTransition>
    </Portal>
  )
}
